module.exports = __webpack_public_path__ + "img/wheel_buyfeature_super_fg.7d8cf117.png";